//  Creating Payment
export const MAKE_PAYMENT_REQUEST = 'MAKE_PAYMENT_REQUEST';
export const MAKE_PAYMENT_SUCCESS = 'MAKE_PAYMENT_SUCCESS';
export const MAKE_PAYMENT_FAIL = 'MAKE_PAYMENT_FAIL';

// Clearing Payment State
export const CLEAR_PAYMENT_STATE = 'CLEAR_PAYMENT_STATE';

//  Get Payments By Ro
export const GET_PAYMENTS_BY_RO_REQUEST = 'GET_PAYMENTS_BY_RO_REQUEST';
export const GET_PAYMENTS_BY_RO_SUCCESS = 'GET_PAYMENTS_BY_RO_SUCCESS';
export const GET_PAYMENTS_BY_RO_FAIL = 'GET_PAYMENTS_BY_RO_FAIL';

//  Get Approved Jobs
export const GET_APPROVED_JOBS_REQUEST = 'GET_APPROVED_JOBS_REQUEST';
export const GET_APPROVED_JOBS_SUCCESS = 'GET_APPROVED_JOBS_SUCCESS';
export const GET_APPROVED_JOBS_FAIL = 'GET_APPROVED_JOBS_FAIL';
export const CLEAR_APPROVED_JOBS_STATE = 'CLEAR_APPROVED_JOBS_STATE';

//  Get Payments
export const GET_PAYMENTS_REQUEST = 'GET_PAYMENTS_REQUEST';
export const GET_PAYMENTS_SUCCESS = 'GET_PAYMENTS_SUCCESS';
export const GET_PAYMENTS_FAIL = 'GET_PAYMENTS_FAIL';

//  Add Edit Payment Notes
export const ADD_EDIT_PAYMENT_NOTES_REQUEST = 'ADD_EDIT_PAYMENT_NOTES_REQUEST';
export const ADD_EDIT_PAYMENT_NOTES_SUCCESS = 'ADD_EDIT_PAYMENT_NOTES_SUCCESS';
export const ADD_EDIT_PAYMENT_NOTES_FAIL = 'ADD_EDIT_PAYMENT_NOTES_FAIL';
